export default <F extends (...args: unknown[]) => void>(
  func: F,
  delay = 50
): ((context: ThisParameterType<F>, ...args: Parameters<F>) => void) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;

  return (context: ThisParameterType<F>, ...args: Parameters<F>) => {
    if (timeout === undefined) {
      timeout = setTimeout(() => {
        func.apply(context, args);

        timeout = undefined;
      }, delay);
    }
  };
};
